import {Fragment, useEffect, useState, useContext} from 'react';

import LoginContext from '../../../../../store/login-context';
import Skip from '../Skip/Skip';
import classes from './MainOptions.module.scss';
import bulb from '../../../../../assets/icons/bulb-fill-blue.svg';
import info from '../../../../../assets/icons/info-yellow.svg';
import ProgressBar from '../ProgressBar/ProgressBar';
import Toast from '../../../../Form/Toast';

declare var _curLang: any;
declare function Translate(key: string): string;

const MainOptions = (props) => {

    const ctx = useContext(LoginContext);

    const [ccChecked,setCcChecked] = useState(false);
    const [passportChecked,setPassportChecked] = useState(false);
    const [imgCertChecked,setImgCertChecked] = useState(false);
    const [selectedIds, setSelectedIds] = useState<string[]>([]);
    const [showErrorMsg,setShowErrorMsg] = useState(false);
    
    useEffect(() => {                        
        // if(ctx.summaryRegOptions.length > 0){
        //     ctx.updateSummaryRegOptions([]);
        // }

        // Check for previous selected options
        const userOptions = ctx.summaryRegOptions.slice(); 
        if (userOptions.length > 0){ 
            const mainOptionsIdsArr = userOptions[0].split(',');
            let selectedOptions: string[] = [];
            
            mainOptionsIdsArr.forEach((option) => {
                switch (option) {                   
                    case "creditCard":
                        setCcChecked(true);  
                        selectedOptions.push("creditCard");           
                        break;
                    case "passport":
                        setPassportChecked(true);
                        selectedOptions.push("passport"); 
                        break;
                    case "imiggrationCert":
                        setImgCertChecked(true);
                        selectedOptions.push("imiggrationCert");
                        break;                              
                    default:
                        break;
                }               
            })

            setSelectedIds(selectedOptions); 
        }
        // else{
        //     if(ctx.summaryRegOptions.length > 0){
        //         ctx.updateSummaryRegOptions([]);
        //     }
        // }


    },[]);
      
    
    const handleCheckBoxClick = (event) => {
        
        switch (event.target.id) {
            case "creditCard":
                setCcChecked(!ccChecked);       
                break;
            case "passport":
                setPassportChecked(!passportChecked);
                break;
            case "imiggrationCert":
                setImgCertChecked(!imgCertChecked);
                break;
            default:
                break;
        } 
        
        //Array of selected options
        if(selectedIds.indexOf(event.target.id) === -1){
            if(selectedIds.length >= 2 ){
                setShowErrorMsg(true);               
            }

            setSelectedIds([...selectedIds,event.target.id]); 
                    
        }
        else{
            let index = selectedIds.findIndex(x => x === event.target.id);
            selectedIds.splice(index, 1);
            setSelectedIds([...selectedIds]);

            if(selectedIds.length <= 2){
                setShowErrorMsg(false);  
            }
        }
    };

    const handleCheckBoxPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13){            
            handleCheckBoxClick(event);
        }       
    }

    const handleNoOption = () => {
        props.setCurrentScreenStep(ctx.preRegScreenCollection.bioIdFirst);
        props.AddUserStep(ctx.preRegScreenCollection.bioIdFirst);
    };

    const handleContinue = () => {
        if(ctx.summaryRegOptions.length <= 1){
            ctx.updateSummaryRegOptions([selectedIds.join()]);
        }
        else if(ctx.summaryRegOptions.length > 1){
            const regOptions = ctx.summaryRegOptions.slice();
            regOptions[0] = selectedIds.join();
            ctx.updateSummaryRegOptions(regOptions);
        }

        if(selectedIds.length === 1){
            if(ctx.summaryRegOptions.length <= 1){
                ctx.updateSummaryRegOptions([selectedIds.join()]);
            }
            else if(ctx.summaryRegOptions.length > 1){
                const regOptions = ctx.summaryRegOptions.slice();
                regOptions[0] = selectedIds.join();
                ctx.updateSummaryRegOptions(regOptions);
            }
            props.setCurrentScreenStep(ctx.preRegScreenCollection.alternativeOptions);
            props.AddUserStep(ctx.preRegScreenCollection.alternativeOptions);
        }
        else if(selectedIds.length > 1){
            ctx.updateSummaryRegOptions([selectedIds.join()]);
            props.setCurrentScreenStep(ctx.preRegScreenCollection.summaryOptions);
            props.AddUserStep(ctx.preRegScreenCollection.summaryOptions);
        }
    };

   
    return(
        <Fragment>
             <ProgressBar pbWidth="34%"/>
            <div className={classes.container}>
                <div className={classes.formWrapper}>                          
                    <div className={`preRegTitleBold ${classes.title}`}>{Translate('N_SignUp_Prefered_Options')}</div>
                    <div className={classes.desc_container}>
                        <div className={`preRegText ${classes.desc}`}>
                            <img src={bulb} alt="bulb" className={classes.bulb}/>
                            <span className={classes.desc_text}>{Translate('N_SignUp_Options_Instructions')}</span>                        
                        </div>                    
                    </div>

                    {/* Credit Card */}
                    <div className={classes.check_container}>
                        <div>
                            <input 
                                    type="checkbox" 
                                    id="creditCard" 
                                    className={classes.check} 
                                    checked={ccChecked}
                                    onChange={handleCheckBoxClick}
                                    onKeyPress={handleCheckBoxPress} 
                                >                        
                            </input>
                        </div>
                        <div>
                            <label htmlFor='creditCard'>
                                <span className={classes.check_label}>{Translate('N_Login_SignUp_Credit_Card')}</span>
                                <span className={classes.check_label}>({Translate('N_General_SignUp_credit_info')})</span>  
                                <span>                                   
                                    <a className='gov-tooltip tooltipLink' tabIndex={0} role='button'>
                                        <div className="gov-tooltiptitle">{Translate('N_General_Credit_Card_Options')}</div>
                                        <div className={`gov-tooltiptext ${classes.main_tooltipText}`} tabIndex={0}>
                                            <div className={classes.bullet_container}>
                                                <div className={classes.bullet}>&#x2022;</div>
                                                <div>{Translate('N_General_Credit_Card_Option_1')}</div> 
                                            </div>
                                            <div className={classes.bullet_container}>
                                                <div className={classes.bullet}>&#x2022;</div>
                                                <div>{Translate('N_General_Credit_Card_Option_2')}</div> 
                                            </div>
                                            <div className={classes.bullet_container}>
                                                <div className={classes.bullet}>&#x2022;</div>
                                                <div>{Translate('N_General_Credit_Card_Option_3')}</div> 
                                            </div>
                                            <div className={classes.bullet_container}>
                                                <div className={classes.bullet}>&#x2022;</div>
                                                <div>{Translate('N_General_Credit_Card_Option_4')}</div> 
                                            </div>                                           
                                        </div>
                                    </a> 
                                </span>                  
                            </label>
                        </div>
                    </div> 

                    {/* Passport */}
                    <div className={classes.check_container}>
                        <div>
                            <input 
                                    type="checkbox" 
                                    id="passport" 
                                    className={classes.check} 
                                    checked={passportChecked}
                                    onChange={handleCheckBoxClick}
                                    onKeyPress={handleCheckBoxPress} 
                                >                        
                            </input>
                        </div>
                        <div>
                            <label htmlFor='passport'>
                                <span className={classes.check_label}>{Translate('N_Login_SignUp_Passport')}</span>                    
                            </label>
                        </div>
                    </div>

                    {/* immigration certificate */}
                    <div className={classes.check_container}>
                        <div>
                            <input 
                                    type="checkbox" 
                                    id="imiggrationCert" 
                                    className={classes.check} 
                                    checked={imgCertChecked}
                                    onChange={handleCheckBoxClick}
                                    onKeyPress={handleCheckBoxPress} 
                                >                        
                            </input>
                        </div>
                        <div>
                            <label htmlFor='imiggrationCert'>
                                <span className={classes.check_label}>{Translate('N_Login_SignUp_Immigration_Cert')}</span><br />
                                <span className={classes.check_label_remark}>{Translate('N_Login_SignUp_Immigration_Cert_Desc')}</span>                   
                            </label>
                        </div>
                    </div>  
            
                    <div className={classes.buttons_container}>
                        {showErrorMsg && <Toast message={Translate('N_Login_SignUp_Options_Error')}/>}
                        <div className={classes.buttons_wrapper}>
                            <button 
                                className={`${classes.btn_no_idn} ${_curLang === 'en' || _curLang === 'ru' ? classes.btn_no_idn_ltr : ''}`} 
                                id='btnMainNoIdentityOptions' 
                                onClick={handleNoOption}>
                                <span>{Translate('N_Login_SignUp_No_Idn_Options')}</span>                     
                            </button>
                            <button 
                                className={classes.btn_continue} 
                                id='btnMainContinue' 
                                onClick={handleContinue}
                                disabled={(!ccChecked && !passportChecked && !imgCertChecked) || selectedIds.length > 2}
                                >
                                <span>{Translate('N_General_next')}</span>                     
                            </button>
                        </div>
                    </div>
                    <div className={classes.buttons_container_mobile}>
                        {showErrorMsg && <Toast message={Translate('N_Login_SignUp_Options_Error')}/>}    
                        <button 
                            className={classes.btn_continue} 
                            id='btnMainContinueMobile' 
                            onClick={handleContinue}
                            disabled={(!ccChecked && !passportChecked && !imgCertChecked) || selectedIds.length > 2}
                            >
                            <span>{Translate('N_General_next')}</span>                     
                        </button>
                        <button 
                            className={`${classes.btn_no_idn} ${_curLang === 'en' || _curLang === 'ru' ? classes.btn_no_idn_ltr : ''}`} 
                            id='btnMainNoIdentityOptionsMobile' 
                            onClick={handleNoOption}>
                            <span>{Translate('N_Login_SignUp_No_Idn_Options')}</span>                     
                        </button>                    
                    </div>
                </div>
                <div className={classes.skip}>
                    <Skip />
                </div>
            </div>                 
        </Fragment>       
    );
};
export default MainOptions;